import React from 'react';
import { ArrowRight, CreditCard, Users, Flame, Zap } from 'lucide-react';
import { useJoinStats } from './join/LiveStats';
import { useLanguage } from '../context/LanguageContext';
import { DriveGoal } from './DriveGoal';
import AppLink from './AppLink';

export const DriveSection = () => {
  const { t } = useLanguage();
  const { stats } = useJoinStats();
  const items = [
    { icon: Users, val: stats?.total, label: { en: 'joined online', bn: 'অনলাইনে যোগ' }, id: 'total' },
    { icon: Flame, val: stats?.today, label: { en: 'last 24h', bn: 'গত ২৪ ঘণ্টা' }, id: 'today' },
    { icon: Zap, val: stats?.youth, label: { en: 'youth 18-30', bn: 'তরুণ ১৮-৩০' }, id: 'youth' },
  ];
  return (
    <section className="relative overflow-hidden bg-[#0B0B0F] py-5 text-white" data-testid="home-drive-section">
      <div className="pointer-events-none absolute -left-16 top-1/2 h-40 w-40 -translate-y-1/2 rounded-full bg-[#00A651] opacity-25 blur-3xl" />
      <div className="pointer-events-none absolute -right-16 top-1/2 h-40 w-40 -translate-y-1/2 rounded-full bg-[#E30613] opacity-25 blur-3xl" />
      <div className="relative mx-auto flex max-w-7xl flex-col gap-4 px-4 sm:px-6 lg:flex-row lg:items-center lg:gap-8 lg:px-8">
        <div className="shrink-0">
          <span className="font-join inline-flex items-center gap-2 text-[11px] font-bold uppercase tracking-[0.2em] text-[#00E676]" data-testid="home-drive-badge">
            <span className="relative flex h-2 w-2"><span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-[#00E676] opacity-75" /><span className="relative inline-flex h-2 w-2 rounded-full bg-[#00E676]" /></span>
            {t({ en: 'Membership Drive 2026 · Live', bn: 'সদস্যপদ অভিযান ২০২৬ · চলছে' })}
          </span>
          <p className="font-join mt-1 text-xl font-black leading-tight sm:text-2xl">
            {t({ en: 'Your voice.', bn: 'আপনার কণ্ঠ।' })} <span className="text-[#FF3B3B]">{t({ en: 'Your NDP.', bn: 'আপনার এনডিপি।' })}</span>
          </p>
        </div>
        <div className="min-w-0 flex-1">
          <DriveGoal compact />
          <div className="mt-2 flex flex-wrap gap-x-4 gap-y-1 text-xs text-white/60" data-testid="home-drive-stats">
            {items.map(({ icon: Icon, val, label, id }) => (
              <span key={id} className="inline-flex items-center gap-1">
                <Icon className="h-3.5 w-3.5 text-[#00E676]" />
                <b className="font-join text-sm text-white" data-testid={`home-drive-stat-${id}`}>{val ?? '—'}</b> {t(label)}
              </span>
            ))}
          </div>
        </div>
        <div className="flex shrink-0 gap-2">
          <AppLink to="/join" data-testid="home-drive-join-btn" className="font-join inline-flex items-center gap-1.5 rounded-full bg-[#FF3B3B] px-5 py-2.5 text-sm font-bold text-white transition-transform duration-200 hover:scale-[1.03]">
            {t({ en: 'Join now', bn: 'যোগ দিন' })} <ArrowRight className="h-4 w-4" />
          </AppLink>
          <AppLink to="/member-card" data-testid="home-drive-idcard-btn" className="inline-flex items-center gap-1.5 rounded-full border border-white/25 px-4 py-2.5 text-sm font-semibold text-white transition-colors duration-200 hover:bg-white hover:text-black">
            <CreditCard className="h-4 w-4" /> {t({ en: 'ID Card', bn: 'আইডি কার্ড' })}
          </AppLink>
        </div>
      </div>
    </section>
  );
};
